var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loadFailed
        ? _c(
            "v-alert",
            {
              staticClass: "mb-4",
              attrs: {
                type: "error",
                text: "",
                dense: ""
              }
            },
            [
              _vm._v(" We couldn't load the mailboxes on this account. "),
              _c(
                "gg-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    small: "",
                    tertiary: ""
                  },
                  on: {
                    click: _vm.load
                  }
                },
                [_vm._v("Try again")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.loading && !_vm.mailboxOptions.length
        ? _c("gg-loading", {
            attrs: {
              loading: true,
              type: "card"
            }
          })
        : !_vm.mailboxOptions.length && !_vm.loadFailed
        ? _c("feature-setup", {
            attrs: {
              feature: "accounts"
            },
            on: {
              create: function create($event) {
                return _vm.$emit("create-mailbox")
              }
            }
          })
        : _vm.mailboxOptions.length
        ? [
            _c(
              "v-row",
              {
                staticClass: "mb-2"
              },
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "8",
                      md: "5"
                    }
                  },
                  [
                    _c("gg-select", {
                      attrs: {
                        value: _vm.mailbox && _vm.mailbox.email,
                        label: "Mailbox",
                        items: _vm.mailboxOptions,
                        "hide-details": ""
                      },
                      on: {
                        change: _vm.select
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            !_vm.mailbox
              ? _c(
                  "gg-card",
                  [
                    _c("gg-card-text", [
                      _c(
                        "div",
                        {
                          staticClass: "py-8 text-center"
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2 font-weight-medium"
                            },
                            [_vm._v("We couldn't find this mailbox.")]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "mb-0"
                            },
                            [
                              _vm._v(
                                "It may have been deleted. Pick another one above."
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              : _c(_vm.panel, {
                  key: _vm.mailbox.id,
                  tag: "component",
                  attrs: {
                    mailbox: _vm.mailbox
                  },
                  on: {
                    changed: _vm.reload
                  }
                })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }